import { usesDesignV2 } from '../features/design-v2/rollout';
import type { PageContext, PageDefinition } from '../lib/types';
import { getFlow } from '../api/flows';
import { getProject } from '../api/workspace';
import { CanvasEditor } from '../features/canvas/CanvasEditor';
export function redirect(ctx: PageContext): null {
  const flow = getFlow(ctx.params.flowId);
  location.replace(flow ? `#/projects/${flow.project_id}/flows/${flow.id}` : '#/projects');
  return null;
}
export function render(ctx: PageContext): PageDefinition {
  const flow = getFlow(ctx.params.flowId);
  const project = flow && getProject(flow.project_id);
  if (!project || flow.project_id !== ctx.params.projectId) return { title: 'Not found', content: <div className="page"><div className="empty">Flow not found. <a href="#/projects">Back to projects</a></div></div> };
  const appMode = ctx.query.mode === 'app';
  const legacyAppMode = appMode && !usesDesignV2(ctx);
  return { title: flow.name, mainClass: 'flow-main', content: <CanvasEditor key={`${flow.id}:${appMode ? legacyAppMode ? 'app-v1' : 'app-v2' : 'canvas'}`} flowId={flow.id} projectId={project.id} flowName={flow.name} projectName={project.name} initialAppMode={appMode} legacyAppMode={legacyAppMode} /> };
}
